import dayjs from 'dayjs';
import { addYbResponseData, addYbRquestData } from "@/api/yb";
import { buildYbRequest, generateYbHeaders, sendYbRequest } from "@/api/yb/ybApi";

/**
 * 医保交易服务类 - 只负责发起请求
 */
export class ybOutpatientMedical {
    constructor() {
        this.isRequesting = false;
    }

    /**
     * 统一的请求处理方法
     */
    async _handleRequest(infno, ybTemplate, userInfo) {
        try {
            const res = await addYbRquestData({
                infno,
                mdtrtareaAdmvs: userInfo.mdtrtareaAdmvs,
                data: JSON.stringify(ybTemplate),
                patientId: userInfo.staffId,
                patientName: userInfo.staffName
            });

            if (res.code !== 200) {
                return {
                    success: false,
                    error: res.message || '未知错误'
                };
            }

            const headers = generateYbHeaders({
                infosyscode: res.data.infosyscode,
                signature: res.data.signature,
                clinicCode: userInfo.clinicCode,
                hsfNonce: res.data.hsfNonce,
                hsfTimestamp: res.data.hsfTimestamp
            });

            const ybResponse = await sendYbRequest(ybTemplate.body, headers);

            await addYbResponseData({
                id: res.data.id,
                infno,
                data: JSON.stringify(ybResponse)
            });

            return {
                success: true,
                data: ybResponse,
                requestInfo: {
                    infosyscode: res.data.infosyscode,
                    signature: res.data.signature
                }
            };

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 1101交易 - 获取患者医保信息
     */
    async handleYB_1101_Upload(params) {
        const { userInfo, patientForm } = params;

        try {
            const ybTemplate = buildYbRequest(params.signNo, '1101');
            ybTemplate.body.input.data = {
                mdtrt_cert_type: "02",
                mdtrt_cert_no: patientForm.certno,
                card_sn: "",
                psn_cert_type: "01",
                certno: patientForm.certno,
                psn_name: "",
            };

            return await this._handleRequest('1101', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2201A交易 - 门诊挂号
     */
    async handleYB_2201A_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, patientForm, rowData } = params;

        try {
            const userYbInfo = outpatientYbRegisterForm.yb_1101_ReturnInfo.insuinfo
                ?.filter(item => item.psn_insu_stas === '1')
                ?.find(item => item.insutype === '310');

            const ybTemplate = buildYbRequest(signNo, '2201A', userYbInfo.insuplc_admdvs);
            ybTemplate.body = {
                ...ybTemplate.body,
                input: {
                    data: {
                        psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                        insutype: userYbInfo.insutype,
                        begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        mdtrt_cert_type: '02',
                        mdtrt_cert_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno,
                        ipt_otp_no: patientForm.patId,
                        atddr_no: rowData.doctorId,
                        dr_name: rowData.doctorName,
                        dept_code: rowData.specialtyCode,
                        dept_name: rowData.deptName,
                        caty: rowData.specialtyName,
                    }
                }
            };

            return await this._handleRequest('2201A', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2202交易 - 门诊挂号撤销
     */
    async handleYB_2202_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, patientForm } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2202');
            ybTemplate.body = {
                ...ybTemplate.body,
                input: {
                    data: {
                        psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                        ipt_otp_no: patientForm.patId,
                        mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                    }
                }
            };

            return await this._handleRequest('2202', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2203A交易 - 门诊信息上传
     */
    async handleYB_2203A_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, rowData } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2203A');
            ybTemplate.body.input.mdtrtinfo = {
                mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                med_type: outpatientYbRegisterForm.med_type,
                begntime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                dise_codg: outpatientYbRegisterForm.dise_codg.split('-')[1],
                dise_name: outpatientYbRegisterForm.dise_codg.split('-')[0],
            };

            ybTemplate.body.input.diseinfo = {
                diag_type: '1',
                diag_srt_no: '1',
                diag_code: outpatientYbRegisterForm.dise_codg.split('-')[1],
                diag_name: outpatientYbRegisterForm.dise_codg.split('-')[0],
                diag_dept: rowData.deptName,
                dise_dor_no: rowData.doctorId,
                dise_dor_name: rowData.doctorName,
                diag_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                vali_flag: '1',
            };

            return await this._handleRequest('2203A', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2204交易 - 门诊费用明细信息上传
     */
    async handleYB_2204_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, rowData, getChargingPriceYbCode, getRandom4Digits } = params;

        try {
            const chargingPriceYb = await getChargingPriceYbCode(rowData.registertypeId);
            if (!chargingPriceYb) {
                return {
                    success: false,
                    error: '获取挂号医保编码失败'
                };
            }

            const ybTemplate = buildYbRequest(signNo, '2204');
            ybTemplate.body.input.feedetail = {
                feedetl_sn: `${userInfo.clinicCode}${dayjs().format('YYYYMMDDHHmmss')}${getRandom4Digits()}`,
                mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                chrg_bchno: `${outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
                rx_circ_flag: '0',
                fee_ocur_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                med_list_codg: chargingPriceYb.isocode,
                medins_list_codg: chargingPriceYb.isocode,
                det_item_fee_sumamt: rowData.price,
                cnt: 1,
                pric: rowData.price,
                bilg_dept_codg: userInfo.deptDepts.find(item => item.id === userInfo.selDept).deptCode,
                bilg_dept_name: userInfo.deptDepts.find(item => item.id === userInfo.selDept).deptName,
                hosp_appr_flag: '2',
                medins_list_name: chargingPriceYb.costname
            };

            return await this._handleRequest('2204', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2205交易 - 门诊费用明细撤销
     */
    async handleYB_2205_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2205');
            ybTemplate.body = {
                ...ybTemplate.body,
                input: {
                    data: {
                        mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                        chrg_bchno: `${outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
                        psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                    }
                }
            };

            return await this._handleRequest('2205', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2206交易 - 门诊预结算信息上传
     */
    async handleYB_2206_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, rowData } = params;

        try {
            const userYbInfo = outpatientYbRegisterForm.yb_1101_ReturnInfo.insuinfo
                ?.filter(item => item.psn_insu_stas === '1')
                ?.find(item => item.insutype === '310');

            const ybTemplate = buildYbRequest(signNo, '2206', userYbInfo.insuplc_admdvs);
            ybTemplate.body.input.data = {
                psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                mdtrt_cert_type: '02',
                mdtrt_cert_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno,
                med_type: outpatientYbRegisterForm.med_type,
                medfee_sumamt: rowData.price,
                psn_setlway: outpatientYbRegisterForm.psnSetlway,
                mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                chrg_bchno: `${outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
                acct_used_flag: outpatientYbRegisterForm.acct_used_flag,
                insutype: userYbInfo.insutype,
                exp_content:{
                    acct_payamt:outpatientYbRegisterForm.yb_2204_ReturnInfo.pric * outpatientYbRegisterForm.yb_2204_ReturnInfo.cnt
                }
            };

            return await this._handleRequest('2206', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2207交易 - 门诊结算信息上传
     */
    async handleYB_2207_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, rowData } = params;

        try {
            const userYbInfo = outpatientYbRegisterForm.yb_1101_ReturnInfo.insuinfo
                ?.filter(item => item.psn_insu_stas === '1')
                ?.find(item => item.insutype === '310');

            const ybTemplate = buildYbRequest(signNo, '2207', userYbInfo.insuplc_admdvs);
            ybTemplate.body.input.data = {
                psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                mdtrt_cert_type: '02',
                mdtrt_cert_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno,
                med_type: outpatientYbRegisterForm.med_type,
                medfee_sumamt: rowData.price,
                psn_setlway: outpatientYbRegisterForm.psnSetlway,
                mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                chrg_bchno: `${outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
                insutype: userYbInfo.insutype,
                acct_used_flag: outpatientYbRegisterForm.acct_used_flag,
                fulamt_ownpay_amt: outpatientYbRegisterForm.yb_2206_ReturnInfo.psn_part_amt,
                overlmt_selfpay: '',
                preselfpay_amt: '',
                inscp_scp_amt: '',
            };

            return await this._handleRequest('2207', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 2208交易 - 门诊结算撤销
     */
    async handleYB_2208_Upload(params) {
        const { signNo, userInfo, outpatientYbRegisterForm } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2208');
            ybTemplate.body = {
                ...ybTemplate.body,
                input: {
                    data: {
                        setl_id: outpatientYbRegisterForm.yb_2207_ReturnInfo.setl_id,
                        mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                        psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                    }
                }
            };

            return await this._handleRequest('2208', ybTemplate, userInfo);

        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    async handleYB_2203A_Upload_Outpatient(params) {
        const { signNo, userInfo, diagnosisData } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2203A');

            // 门诊收费版的诊断数据结构不同
            ybTemplate.body.input.mdtrtinfo = diagnosisData.mdtrtinfo;
            ybTemplate.body.input.diseinfo = diagnosisData.diseinfo; // 这里是数组，包含多个诊断

            return await this._handleRequest('2203A', ybTemplate, userInfo);
        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 门诊收费版2204交易 - 支持复杂的多费用明细
     */
    async handleYB_2204_Upload_Outpatient(params) {
        const { signNo, userInfo, feeDetailData } = params;

        try {
            const ybTemplate = buildYbRequest(signNo, '2204');

            // 门诊收费版的费用明细是数组，包含多种类型的费用
            ybTemplate.body.input.feedetail = feeDetailData;

            return await this._handleRequest('2204', ybTemplate, userInfo);
        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }

    /**
     * 门诊收费版2206交易 - 预结算 (金额计算方式不同)
     */
    async handleYB_2206_Upload_Outpatient(params) {
        const { signNo, userInfo, outpatientYbRegisterForm, totalAmount } = params;

        try {
            const userYbInfo = outpatientYbRegisterForm.yb_1101_ReturnInfo.insuinfo
                ?.filter(item => item.psn_insu_stas === '1')
                ?.find(item => item.insutype === '310');

            const ybTemplate = buildYbRequest(signNo, '2206', userYbInfo.insuplc_admdvs);
            ybTemplate.body.input.data = {
                psn_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.psn_no,
                mdtrt_cert_type: '02',
                mdtrt_cert_no: outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno,
                med_type: outpatientYbRegisterForm.med_type,
                medfee_sumamt: totalAmount, // 门诊收费使用计算后的总金额
                psn_setlway: outpatientYbRegisterForm.psnSetlway,
                mdtrt_id: outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id,
                chrg_bchno: `${outpatientYbRegisterForm.yb_2201A_ReturnInfo.mdtrt_id}${outpatientYbRegisterForm.yb_1101_ReturnInfo.baseinfo.certno}`,
                acct_used_flag: outpatientYbRegisterForm.acct_used_flag,
                insutype: userYbInfo.insutype,
                exp_content:{
                    acct_payamt : outpatientYbRegisterForm.yb_2204_ReturnInfo.result.reduce((sum, item) => {
                        return sum + (item.cnt * item.pric);
                    }, 0)
                }
            };

            return await this._handleRequest('2206', ybTemplate, userInfo);
        } catch (error) {
            return {
                success: false,
                error: error.message || '未知错误'
            };
        }
    }
}

export default new ybOutpatientMedical();